import {createAction} from '@reduxjs/toolkit'
import {ExperimentNames, LIST_LAYOUT} from '@wix/wix-events-commons-statics'
import {createAsyncAction} from '../services/redux-toolkit'
import {State} from '../types/state'
import {openAnyEventDetails} from './calendar-layout'
import {reloadEvents} from './events'

interface StyleParams {
  numbers: Record<string, number>
  booleans: Record<string, boolean>
}

export const updateStyleParams = createAction<Record<string, number | boolean>>('UPDATE_STYLE_PARAMS')

export const updateStyles = createAsyncAction<void, StyleParams>(
  'UPDATE_STYLES',
  async (params, {dispatch, getState, extra: {flowAPI}}) => {
    const state = getState()
    const layoutChanging = isLayoutChanging(state, params)
    const switchingToCalendar = isSwitchingToCalendar(state, params)

    await dispatch(
      updateStyleParams({
        ...params.numbers,
        ...params.booleans,
      }),
    )

    if (layoutChanging) {
      await dispatch(reloadEvents())

      if (switchingToCalendar && flowAPI.experiments.enabled(ExperimentNames.CalendarRevamp)) {
        dispatch(openAnyEventDetails())
      }
    }
  },
)

const isLayoutChanging = (state: State, params: StyleParams) => {
  const {listLayout, widgetLayout, recurringFilter} = state.component.settings
  const newParamsWithDefaults = {...state.component.settings, ...params.numbers}
  const {
    listLayout: listLayoutNew,
    widgetLayout: widgetLayoutNew,
    recurringFilter: recurringFilterNew,
  } = newParamsWithDefaults

  const isParamChanging = (newValue, oldValue) => newValue !== undefined && oldValue !== newValue

  return (
    isParamChanging(listLayoutNew, listLayout) ||
    isParamChanging(widgetLayoutNew, widgetLayout) ||
    isParamChanging(recurringFilterNew, recurringFilter)
  )
}

const isSwitchingToCalendar = (state: State, params: StyleParams) => {
  const {listLayout} = state.component.settings
  const newParamsWithDefaults = {...state.component.settings, ...params.numbers}
  const {listLayout: listLayoutNew} = newParamsWithDefaults

  return listLayoutNew === LIST_LAYOUT.CALENDAR && listLayout !== LIST_LAYOUT.CALENDAR
}
